import { render, staticRenderFns } from "./DataRecordsTable.vue?vue&type=template&id=23b6798f"
import script from "./DataRecordsTable.vue?vue&type=script&lang=js"
export * from "./DataRecordsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports